<template>
  <div class="document-component">
    <div class="left" @click="openDocument">
      <i class="bx bxs-file-doc bx-md text-primary" />
    </div>
    <div class="right" @click="openDocument">
      <div class="top">
        {{ title }}
      </div>
      <div class="bottom">{{ size }}MO - {{ date }}</div>
    </div>
    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'document',

  props: {
    title: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },

  methods: {
    openDocument() {
      window.open(this.image, '_blank').focus()
    },
  },
}
</script>

<style lang="scss"></style>
